/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for Close Icon.
 *
 * @author Ramani Govindaraju
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const NavClose = (props) => {
  const { color, ...otherProps } = props;
  return (
    <SvgIcon viewBox="0 0 16 16" {...otherProps}>
      <g fill="none" fillRule="evenodd">
        <path d="M-4-4h24v24H-4z" />
        <path
          fill={color}
          fillRule="nonzero"
          d="M8 6.384l6.049-6.05a1.143 1.143 0 0 1 1.616 1.617L9.616 8l6.05
        6.049a1.143 1.143 0 1 1-1.617 1.616L8 9.616l-6.049 6.05a1.143 1.143
        0 1 1-1.616-1.617L6.384 8 .334 1.951A1.143 1.143 0 1 1 1.952.335L8
        6.384z"
        />
      </g>
    </SvgIcon>);
};

NavClose.propTypes = {
  color: PropTypes.string
};

NavClose.defaultProps = {
  color: '#6A7070'
};

export default NavClose;



// WEBPACK FOOTER //
// ./src/js/icons/NavClose.jsx